import { Timestamp } from '@angular/fire/firestore';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Grade } from '../../models/grade.school.model';
import { SchoolMemberType } from '../../models/member.school.model';

export const loadGradeStats = createAction(
  '[School Grade] Load Grades Stats',
  props<{ groupId: string }>(),
);

export const getGrades = createAction(
  '[School Grade] Get Grades',
  props<{
    groupId: string;
    academicYear: number;
    userMemberType?: SchoolMemberType;
    // cursor value for the gradeAvgAge ordering
    lastRecord?: Timestamp | number;
  }>(),
);

export const addGradesToStore = createAction(
  '[School Grade] Add Grades to store',
  props<{ grades: Grade[] }>(),
);
export const addGradeToStore = createAction(
  '[School Grade] Add Grade to store',
  props<{ grade: Grade }>(),
);
export const getGradesFailure = createAction(
  '[School Grade] Get Grades Failed',
  props<{ error: AppExceptionModel }>(),
);

export const getGrade = createAction(
  '[School Grade] Get grade',
  props<{ groupId: string; gradeYear: number; gradeId: string }>(),
);
export const getGradeSuccess = createAction(
  '[School Grade] Get Grade Success',
  props<{ grade: Grade }>(),
);
export const getGradeFailure = createAction(
  '[School Grade] Get Grade Failed',
  props<{ error: AppExceptionModel }>(),
);

// Create Grade Actions
export const create = createAction(
  '[School Grade] Create grade',
  props<{ grade: Grade }>(),
);
export const createFailure = createAction(
  '[School Grade] Create grade failure',
  props<{ error: any }>(),
);
export const createSuccess = createAction(
  '[School Grade] Create grade success',
  props<{ grade: Grade }>(),
);

// Update Grade Actions
export const update = createAction(
  '[School Grade] Update',
  props<{ id: string; grade: Grade }>(),
);
export const updateFailure = createAction(
  '[School Grade] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School Grade] Update Success',
  props<{ grade: Grade }>(),
);

export const reassignGrade = createAction(
  '[School Grade] Reassign',
  props<{
    groupId: string;
    gradeId: string;
    gradeYear: number;
    teacherId?: string;
  }>(),
);

export const reassignGradeSuccess = createAction(
  '[School Grade] Reassign Grade Success',
  props<{ message: string }>(),
);

export const reassignGradeFailure = createAction(
  '[School Grade] Reassign Grade Failure',
  props<{ error: AppExceptionModel }>(),
);

// Delete Grade Actions
export const deleteAction = createAction(
  '[School Grade] Delete',
  props<{ groupId: string; id: string }>(),
);
export const deleteFailure = createAction(
  '[School Grade] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Grade] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Grade] Clear from store',
  props<{ id: string }>(),
);

export const clearFromStore = createAction(
  '[School Grade] Clear multiple from store',
  props<{ ids: string[] }>(),
);

export const clear = createAction('[School Grade] Clear Grades');

// export const clearByAcademicYear = createAction(
//   '[School Grade] Clear Grades By Academic Year',
//   props<{ groupId: string; academicYear: number }>()
// );
